import React from "react";

const AgenticIntelligenceSection = () => {
  return (
    <section className="py-10 md:py-24 bg-gradient-to-b from-background via-slate-50 to-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4 md:mb-6">
            See Beyond the Noise.{" "}
            <span className="text-[#8932c8]">Act with Agentic Intelligence.</span>
          </h2>

          {/* Subtitle */}
          <p className="text-base sm:text-lg md:text-2xl text-center text-muted-foreground mb-8 md:mb-12">
            Complete Visibility. Connected Detection. Coordinated Response.
          </p>

          {/* Description Paragraph */}
          <div className="bg-slate-100 rounded-xl p-5 sm:p-8 md:p-12 mb-8 md:mb-12">
            <p className="text-sm sm:text-base md:text-lg text-foreground leading-relaxed">
              Spharaka delivers a single pane of intelligence across endpoints, networks, identities, and applications, continuously learning, correlating, and acting in real time. AuraXP's <span className="text-[#8932c8] font-semibold">multi-agentic architecture</span>, with over <span className="text-[#8932c8] font-semibold">40</span> specialized AI agents and a vertically trained <span className="text-[#8932c8] font-semibold">Spharaka LLM</span>, drives intelligent, adaptive, and autonomous defense at scale.
            </p>
          </div>

          {/* Two Column Benefits */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
            {/* Left Column */}
            <div className="bg-white rounded-xl p-5 sm:p-8 shadow-sm border border-slate-200">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-foreground mb-2 md:mb-4">
                No more jumping between platforms.
              </h3>
              <p className="text-sm sm:text-base text-muted-foreground">
                Unified security operations in one comprehensive dashboard.
              </p>
            </div>

            {/* Right Column */}
            <div className="bg-white rounded-xl p-5 sm:p-8 shadow-sm border border-slate-200">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-foreground mb-2 md:mb-4">
                No more fragmented alerts.
              </h3>
              <p className="text-sm sm:text-base text-muted-foreground">
                Correlated intelligence that tells the complete story.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgenticIntelligenceSection;
